import React from 'react';
import {
    Grid,
    Box
} from "@material-ui/core/";
import Controls from '../../../../components/controls/Controls';
import { RefusalPresentVaccineItem } from '../../../../forms/shared/termsDeclarations/RefusalPresentVaccineForm';

interface RefusalPresentVaccineTermItemProps {
    RefusalPresentVaccineItem: RefusalPresentVaccineItem;
    onInputChange: (name: string, value: any) => void
}

export default function RefusalPresentVaccineTermItem(props: RefusalPresentVaccineTermItemProps) {

    return (
        <Grid item xs={12} sm={12}>

            <Box style={{ border: '1px solid rgba(224, 224, 224, 1)', borderStyle: 'solid', borderRadius: '16px' }} mt={1} p={1}>
                <Controls.Checkbox
                    name="RefusalPresentVaccineTerm"
                    labelComponent={props.RefusalPresentVaccineItem.Identifier}
                    value={props.RefusalPresentVaccineItem.Checked.Value}
                    onChange={(e) => {
                        props.onInputChange("Checked", e.target.value);
                    }}
                />

                {props.RefusalPresentVaccineItem.Checked.Value === true ? (

                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <Controls.Input name="Reason" multiline={true} rows={3} label="Motivo:" placeholder="Digite o motivo" value={props.RefusalPresentVaccineItem.Reason.Value}
                                onChange={(e) => {
                                    props.onInputChange("Reason", e.target.value);
                                }}
                                onBlur={(e) => {
                                    props.onInputChange("Reason", e.target.value);
                                }}
                                error={null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Controls.DatePicker name="ApplyDate" label="Se já tomou, qual a data *" value={props.RefusalPresentVaccineItem.ApplyDate.Value}
                                onChange={(e) => {
                                    props.onInputChange("ApplyDate", e.target.value);
                                }}
                                onBlur={(e) => {
                                    props.onInputChange("ApplyDate", e.target.value);
                                }}
                                error={props.RefusalPresentVaccineItem.ApplyDate.Error}
                            />
                        </Grid>
                    </Grid>
                ) : <></>}

            </Box>
        </Grid>
    );
}

